<template>
  <div>
  <div class="app-wrapper">
  <div class="notification-bar" v-bind:class="{ 'show-notification-bar': api.notification_banner.banner_activate }" v-if="api.notification_banner.banner_activate !='0'">
    <a v-if="api.notification_banner.banner_link !=''" :href="api.notification_banner.banner_link">
      {{ api.notification_banner.banner_text }} &rarr;
    </a>
    <span v-else>
      {{ api.notification_banner.banner_text }}
    </span>
  </div>
  <div class="logo-3fe"><img src="~@/assets/images/logo-white.svg" alt="3fe"></div>
	<div class="information-wrapper">

      <div v-for="menu in api.menus" class="information__line" v-bind:key="menu.title">
        <a class="button button--menu" :href="menu.pdf" target="_blank">{{ menu.title }}</a>
      </div>

      <a v-on:click.prevent="showReservations = !showReservations" href="#" target="_blank" class="button button--book">Book</a>

	</div>

    <footer class="footer">
      <div class="footer__wrapper">
           <a :href="api.instagram_link" target="_blank" class="footer__instagram">Instagram</a>
           <a :href="api.twitter_link" target="_blank" class="footer__twitter">Twitter</a>
      </div>
    </footer>
    <div class="logo">
      <h1>Gertrude</h1>
    </div>
</div>
<div class="modal-reservations" v-show="showReservations" v-on:click.prevent="showReservations = !showReservations">
	<a href="#" class="modal-reservations__close"><img src="~@/assets/images/close-icon.svg" alt="Close"></a>
	<div id="reservation"></div>
</div>
</div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'home',
  data () {
    return {
      showReservations: false,
      api: {
        twitter_link: null,
        instagram_link: null,
        menu: null,
        notification_banner: {}
      }
    }
  },
  components: {
  },
  mounted () {

    axios
      .get('https://3fe.com/gertrude/index.json')
      .then(response => {
        this.api = response.data
    })    
  }
}
</script>
